import {cssTheme} from '@logistics-frontend/blocks'
import {css} from '@logistics-frontend/blocks/theme/css'

export const classes = {
  selected: css`
    && {
      background-color: ${cssTheme.default.day.backgroundInvert};
    }
  `,
}
